<gl-pro-modal (closeModal)="dismiss()">
  <p class="message">
    <span class="preline">{{ bodyTranslationKey | translate }}</span
    ><a
      normal-link
      class="priceListLink"
      [href]="priceListUrl"
      target="_blank"
      rel="noopener noreferrer"
      >{{ 'price_list_update_link_label' | translate }}</a
    >
  </p>
</gl-pro-modal>
